import {useQuery} from "@tanstack/react-query";
import {IstitutoContrattualeRecord} from "@commons/mapping/IstitutoContrattualeRecord";
import {UseQueryOptions} from "@tanstack/react-query/src/types";
import {SaldoICRecord} from "@commons/mapping/SaldoICRecord";
import {IstitutiContrParams, listIstitutiContrattuali, listRiepilogoIC, RiepilogoICParams} from "@commons/services/presenze_api/riepilogoIC.api";

export function useIstitutiContrattuali(params: IstitutiContrParams | null, opt?: UseQueryOptions) {
    return useQuery<IstitutoContrattualeRecord[] | null>({
        queryKey: ["istitutiContratt", params],
        queryFn: () => {
            return listIstitutiContrattuali(params!)
        },
        enabled: !!params,//===skip
    });
}

export function useRiepilogoIC(params: RiepilogoICParams | null, opt?: UseQueryOptions) {
    const r = useQuery<SaldoICRecord[] | null>({
        queryKey: ["RiepilogoIC", params],
        queryFn: () => {
            return listRiepilogoIC(params!)
        },
        enabled: !!params,//===skip
    });
    return {...r, isLoading: !!params ? r.isLoading : false};
}
